document.addEventListener("DOMContentLoaded", () => {
  const KEY = "recentlyViewedHandles"
  const VIEW = "card"
  const LIMIT = 9

  const container = document.querySelector(".recently-viewed-list")
  const wrapper = document.getElementById("recently-viewed")

  if (!container || !wrapper) return

  let handles = []
  try {
    handles = JSON.parse(localStorage.getItem(KEY)) || []
  } catch (e) {
    console.warn("recently-viewed-products parse error", e)
  }

  // No products -> hide wrapper
  if (handles.length === 0) {
    wrapper.style.display = "none"
    return
  }

  // Remove duplicates and limit
  handles = [...new Set(handles)].slice(0, LIMIT)

  if (handles.length === 0) {
    wrapper.style.display = "none"
    return
  }

  // Fetch product cards in parallel
  Promise.all(
    handles.map(h =>
      fetch(`/products/${encodeURIComponent(h)}?view=${VIEW}`, { cache: "no-store" })
        .then(r => (r.ok ? r.text() : ""))
        .catch(() => "")
    )
  ).then(results => {
    container.replaceChildren()
    results.forEach(html => {
      if (html.trim()) {
        container.insertAdjacentHTML("beforeend", html)
      }
    })
  })
})
